function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 43.99,
  height: 35.266
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  x: 0,
  y: 0,
  width: 43.99,
  height: 35.266
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-5",
  x: 0,
  y: 0,
  width: 11.487,
  height: 20.302
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-7",
  x: 0,
  y: 0,
  width: 11.597,
  height: 8.486
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-9",
  x: 0,
  y: 0,
  width: 11.365,
  height: 12.774
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-11",
  x: 0,
  y: 0,
  width: 11.487,
  height: 19.051
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-13",
  x: 0,
  y: 0,
  width: 11.487,
  height: 9.578
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "HomeMenu-icon-Progress",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "progress-38",
  transform: "translate(15.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.181,7.878 L44.087,0.765 C43.9428016,0.596613856 43.7321914,0.49968892 43.5105,0.49968892 C43.2888086,0.49968892 43.0781984,0.596613856 42.934,0.765 L36.84,7.878 C36.6469383,8.10216888 36.6021574,8.41826417 36.7253562,8.68723735 C36.8485549,8.95621053 37.1171547,9.12876694 37.413,9.129 L41.763,9.129 L41.763,12.466 C41.7624493,12.833041 41.465041,13.1304493 41.098,13.131 L26,13.131 C25.632959,13.1315507 25.3355507,13.428959 25.335,13.796 L25.335,22.038 C25.3339017,22.4048135 25.0368135,22.7019017 24.67,22.703 L9.553,22.703 C9.18595899,22.7035507 8.8885507,23.000959 8.888,23.368 L8.888,31.615 C8.8874493,31.982041 8.59004101,32.2794493 8.223,32.28 L1.165,32.28 C0.797601674,32.2907082 0.504136587,32.5894689 0.5,32.957 L0.5,35.105 C0.5005507,35.472041 0.797958991,35.7694493 1.165,35.77 L11.7,35.77 C12.067041,35.7694493 12.3644493,35.472041 12.365,35.105 L12.365,26.857 C12.3660983,26.4901865 12.6631865,26.1930983 13.03,26.192 L28.141,26.192 C28.508041,26.1914493 28.8054493,25.894041 28.806,25.527 L28.806,17.279 C28.8065507,16.911959 29.103959,16.6145507 29.471,16.614 L44.581,16.614 C44.948041,16.6134493 45.2454493,16.316041 45.246,15.949 L45.246,9.129 L49.6,9.129 C49.8978016,9.13304167 50.170373,8.96231354 50.2967099,8.69260791 C50.4230468,8.42290229 50.3797342,8.10420612 50.186,7.878",
  id: "Trazado_173",
  stroke: "#030303",
  fill: "#F5DDA7",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_85",
  transform: "translate(0.500000, 0.503000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_83-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_66"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_83",
  mask: "url(#mask-2)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.000000, 0.000000)",
  id: "Trazado_174"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.919,8.626 L1.364,8.626 C1.34501141,8.4264481 1.40902993,8.22788217 1.541,8.077 L7.636,0.964 C7.72757696,0.85598496 7.84897301,0.77737319 7.985,0.738 L7.585,0.268 C7.44080161,0.0996138562 7.23019138,0.00268892027 7.0085,0.00268892027 C6.78680862,0.00268892027 6.57619839,0.0996138562 6.432,0.268 L0.34,7.381 C0.150622087,7.60636799 0.109066527,7.92108434 0.233458125,8.18788287 C0.357849723,8.4546814 0.625628304,8.62517443 0.92,8.625"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_84-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_66"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_84",
  mask: "url(#mask-4)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 8.000000)",
  id: "Trazado_175"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.2,25.155 C1.2005507,24.787959 1.49795899,24.4905507 1.865,24.49 L8.913,24.49 C9.28004101,24.4894493 9.5774493,24.192041 9.578,23.825 L9.578,15.584 C9.5785507,15.216959 9.87595899,14.9195507 10.243,14.919 L25.353,14.919 C25.720041,14.9184493 26.0174493,14.621041 26.018,14.254 L26.018,6.012 C26.0185507,5.64495899 26.315959,5.3475507 26.683,5.347 L41.793,5.347 C42.160041,5.3464493 42.4574493,5.04904101 42.458,4.682 L42.458,0.65 L41.258,0.65 L41.258,3.987 C41.2574493,4.35404101 40.960041,4.6514493 40.593,4.652 L25.4999921,4.652 C25.132959,4.6525507 24.8355507,4.94995899 24.835,5.317 L24.835,13.559 C24.8339017,13.9258135 24.5368135,14.2229017 24.17,14.224 L9.053,14.224 C8.68595899,14.2245507 8.3885507,14.521959 8.388,14.889 L8.388,23.137 C8.3874493,23.504041 8.09004101,23.8014493 7.723,23.802 L0.665,23.802 C0.489597595,23.7976723 0.319916361,23.8645476 0.194631843,23.9873829 C0.0693473255,24.1102183 -0.000864424095,24.2785463 -7.88840716e-06,24.454 L-7.88840716e-06,26.601 C0.000550700118,26.968041 0.297958991,27.2654493 0.665,27.266 L1.2,27.266 L1.2,25.155 Z"
}))))), /*#__PURE__*/React.createElement("path", {
  d: "M44.587,20.091 L34.052,20.091 C33.6851865,20.0920983 33.3880983,20.3891865 33.387,20.756 L33.387,48.156 C33.3880983,48.5228135 33.6851865,48.8199017 34.052,48.821 L44.587,48.821 C44.9538135,48.8199017 45.2509017,48.5228135 45.252,48.156 L45.252,20.756 C45.2509017,20.3891865 44.9538135,20.0920983 44.587,20.091",
  id: "Trazado_176",
  fill: "#E5E3E3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_87-Clipped",
  transform: "translate(33.387000, 20.091000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_68"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_87",
  mask: "url(#mask-6)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.3,12.49 C4.30980364,7.66783321 7.46038176,3.40575062 11.481,0.07 C11.3918482,0.025643826 11.2935762,0.00270227208 11.194,0.00299713878 L0.665,0.00299713878 C0.298186515,0.00409825134 0.00109825134,0.301186515 0,0.668 L0,20.296 C0.452790158,17.6109805 1.2249351,14.9897163 2.3,12.488",
  id: "Trazado_177"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_90-Clipped",
  transform: "translate(0.500000, 39.252000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_69"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_90",
  mask: "url(#mask-8)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.872,7.186 C3.39291783,3.52767999 7.24194632,0.997539338 11.6,0.134 C11.4853448,0.0459687556 11.3445471,-0.00119845772 11.2,-2.22868137e-05 L0.665,-2.22868137e-05 C0.298186515,0.00109825134 0.00109825134,0.298186515 0,0.665 L0,8.48 C0.275,8.047 0.561,7.614 0.872,7.187",
  id: "Trazado_178"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_93-Clipped",
  transform: "translate(16.940000, 29.669000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-10",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_70"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_93",
  mask: "url(#mask-10)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.365,0.024 C11.311034,0.0100356386 11.255708,0.00198822439 11.2,0 L0.671,0 C0.303958991,0.000550700118 0.00655070012,0.297958991 0.006,0.665 L0.006,12.774 C2.29740471,7.39696699 6.28718088,2.91861095 11.365,0.024",
  id: "Trazado_179"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M12.371,39.472 L12.371,48.604 C12.371,48.726 12.071,48.8300295 11.7,48.8300295 L1.165,48.8300295 C0.8,48.832 0.5,48.732 0.5,48.604 L0.5,39.472 C0.5,39.35 0.8,39.252 1.165,39.252 L11.694,39.252 C12.066,39.252 12.371,39.352 12.371,39.472",
  id: "Trazado_180",
  fill: "#F4A4A4",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.811,30.114 L28.811,48.385 C28.811,48.629 28.511,48.830036 28.146,48.830036 L17.611,48.830036 C17.4595854,48.8313726 17.3104005,48.7934735 17.178,48.72 C17.0426867,48.6605678 16.9511697,48.5313673 16.94,48.384 L16.94,30.114 C16.94,29.87 17.24,29.669 17.605,29.669 L28.14,29.669 C28.1644871,29.6680108 28.1890031,29.6700258 28.213,29.675 C28.549,29.699 28.813,29.889 28.813,30.114",
  id: "Trazado_181",
  fill: "#E5E3E3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_96-Clipped",
  transform: "translate(16.940000, 29.669000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-12",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-11"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_71"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_96",
  mask: "url(#mask-12)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.487,0.067 C7.46420572,3.40190799 4.31324599,7.66553643 2.306,12.49 C1.39998883,14.6037446 0.707221584,16.8026441 0.238,19.054 C0.102686712,18.9945678 0.011169707,18.8653673 -6.77620369e-06,18.718 L-6.77620369e-06,0.671 C-0.000797438573,0.493834845 0.0688172906,0.323609325 0.193529368,0.197772026 C0.318241445,0.0719347273 0.487834829,0.000793865286 0.665,0 L11.2,0 C11.2244871,-0.000989196721 11.2490031,0.00102581815 11.273,0.006 C11.3475973,0.01235542 11.4202632,0.033068589 11.487,0.067",
  id: "Trazado_182"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_99-Clipped",
  transform: "translate(0.500000, 39.252000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-14",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-13"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rect\\xE1ngulo_72"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_99",
  mask: "url(#mask-14)",
  fill: "#F5CECE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.487,0.067 C8.29268539,2.69437013 5.64933796,5.927356 3.709,9.58 L0.665,9.58 C0.3,9.58 -3.03008973e-06,9.48 -3.03008973e-06,9.358 L-3.03008973e-06,0.665 C-0.000533332734,0.488468075 0.0693576873,0.319012669 0.194185178,0.194185178 C0.319012669,0.0693576873 0.488468075,-0.000533332734 0.665,-2.9888909e-05 L11.194,-2.9888909e-05 C11.295572,-0.000976272071 11.3959468,0.0219763387 11.487,0.067",
  id: "Trazado_183"
})))));
function SvgHomeMenuIconProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeMenu-icon-Progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIconProgress);
export default __webpack_public_path__ + "static/media/HomeMenu-icon-Progress.3ed2bb322fc22537f89df9690b32feb0.svg";
export { ForwardRef as ReactComponent };